import template from './test-drive-popup.html';
import controller from './test-drive-popup.controller';
import './test-drive-popup.scss';

let introductionPopup = {
  bindings: {
    onClose: '&'
  },
  controllerAs: 'vm',
  template,
  controller
};

export default introductionPopup;



// WEBPACK FOOTER //
// ./client/app/components/popups/dashboard/test-drive-popup/test-drive-popup.component.js